import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {NgbModal, NgbPopoverModule} from '@ng-bootstrap/ng-bootstrap';
import {GeotabLcService} from '../../geotab-lc.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {EulaComponent} from '../eula/eula.component';
import {SessionResponse} from '../../models/session-response';
import {AuthResponse} from '../../models/auth-response';
import {firstValueFrom} from 'rxjs';
import {AuthenticationService} from '../../auth/authentication.service';
import {ErrorHandlingComponent} from '../error-handling/error-handling.component';

import {FaqsComponent} from '../faqs/faqs.component';
import {TabNavigationComponent} from '../tab-navigation/tab-navigation.component';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  standalone: true,
  imports: [
    TranslatePipe,
    NgbPopoverModule,
    TabNavigationComponent
],
  styleUrl: './admin.component.scss'
})
export class AdminComponent implements OnInit, OnDestroy {
  isEulaAccepted: string;
  lifeCycleHandler = null;
  private eulaChecked = false;
  sessionResponse: SessionResponse;
  showView:boolean;
  reloadFlag = false;
  // admin.component.ts
  entries = [
    { label: 'dataProtection', link: 'https://www.bosch.us/privacy-notice/?prevent-auto-open-privacy-settings=1' },
    { label: 'legalNotice', link: 'https://www.bosch.us/notices/?prevent-auto-open-privacy-settings=1' },
    { label: 'corporateInformation', link: 'https://www.bosch.us/corporate-information/?prevent-auto-open-privacy-settings=1' }
  ];
  constructor(private readonly modalService: NgbModal,
              public geotabLcService: GeotabLcService,
              private readonly spinnerService: NgxSpinnerService,
              private readonly cdRef: ChangeDetectorRef,
              private readonly authenticationService: AuthenticationService
              ) {
  }

  /* istanbul ignore next */
  ngOnInit(){
    this.lifeCycleHandler = this.geotabLcService.geotablc$.subscribe(async (lifecycle) => {
      console.log('Lifecycle', lifecycle);
      if (lifecycle === 'initialized' || lifecycle === 'focused') {
        // This is to eliminate double calls to the EULA check since initialized and focused are called in quick succession
        if (!this.eulaChecked) {
          this.eulaChecked = true;
          this.checkEula();
        }
      }
    });
  }

  /* istanbul ignore next */
  ngOnDestroy(): void {
    this.lifeCycleHandler.unsubscribe();
  }

  /* istanbul ignore next */
  async authenticate() {
    this.spinnerService.show();
    const res = sessionStorage.getItem('ridecare_' + sessionStorage.getItem('database'));
    this.sessionResponse = JSON.parse(res);
    try {
      const authResponse: AuthResponse = await firstValueFrom(this.authenticationService.getOAuthToken(this.sessionResponse));
      sessionStorage.setItem('authToken_' + sessionStorage.getItem('database'), authResponse.authenticationResult.accessToken);
      sessionStorage.setItem('refreshToken_' + sessionStorage.getItem('database'), authResponse.authenticationResult.refreshToken);
      sessionStorage.setItem('tenant_' + sessionStorage.getItem('database'), authResponse.tenant);
      this.showView = true;
      this.cdRef.detectChanges();
    } catch (error: any) {
      if (error.status) {
        const modalRef = this.modalService.open(ErrorHandlingComponent, {
          centered: true,
          backdropClass: 'backdrop-class',
          size: 'sm',
        });
        modalRef.componentInstance.error = error;
      }
    } finally {
      this.spinnerService.hide();
      this.eulaChecked= false;
    }
  }

  /* istanbul ignore next */
  async checkEula() {
    await this.spinnerService.hide();
    const rcEulaAccepted = localStorage.getItem('rcEulaAccepted');
    if(rcEulaAccepted) {
      localStorage.removeItem('rcEulaAccepted');
    }
    this.isEulaAccepted = localStorage.getItem('isEulaAccepted');
    if(this.isEulaAccepted === 'false') {
      const modelRef = this.modalService.open(EulaComponent, {
        centered: true,
        backdropClass: 'backdrop-class',
        backdrop: 'static',
        keyboard: false,
      });
      modelRef.closed.subscribe(async (result) => {
        if (result === 'accepted') {
          localStorage.setItem('isEulaAccepted', 'true');
          await this.authenticate();
          this.reloadComponent();
        } else {
          localStorage.setItem('isEulaAccepted', 'false');
          this.showView = false;
        }
      })
    } else {
      await this.authenticate();
      this.reloadComponent();
    }
  }

  /* istanbul ignore next */
  openFaqs() {
    const modelRef = this.modalService.open(FaqsComponent, {
      centered: true,
      backdropClass: 'backdrop-class',
      backdrop: 'static',
      size: 'xl',
      scrollable: true,
    });
    modelRef.componentInstance.name = 'FAQs';
  }

  /* istanbul ignore next */
  reloadComponent() {
  this.reloadFlag = !this.reloadFlag;
  }
}
